module.exports = __webpack_public_path__ + "img/655.c086d42c.png";